export {
  bankAccountProductListScreen,
  bankAccountProductDetailScreen,
} from './bank-account-product.screen';
export { productListSearch, productDetailSearch } from './bank-account-product.search';
export { loadBankAccountProductMessages } from './bank-account-product.catalog';
export const loadBankAccountProductScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBankAccountProductGuides = () => import('./bank-account-product.guide');
